import styled from '@emotion/styled';

export default styled.div`
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 2px;
  margin-top: 1rem;
  font-size: 0.75rem;
`;
